
  import Header from '@/components/Header.vue';
  import { AccountModule, AccountStore } from '@/store/account';
  import { Options, Vue } from 'vue-class-component';

  @Options({
    components: {
      Header
    }
  })
  export default class ReportsComponent extends Vue {
    private accountStore: AccountModule = AccountStore;

    mounted() {
      this.accountStore.initAuthDataFromLocalStorage();
    }
  }
